import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mantenimiento-programado',
    templateUrl: './mantenimiento-programado.component.html',
    styleUrls: ['./mantenimiento-programado.component.scss'],
    standalone: false
})
export class MantenimientoProgramadoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
